import React from 'react';
import * as settings from '../../settings';

import styles from './VideoPlayer.scss';

function VideoPlayer(props) {
  const { batteryPopDistributionID, batteryPopSeriesID } = props.series;
  const { video, autoplay, autoresume, mute } = props;
  let src = `https://player.batterypop.net/player/content/?distribution_id=${batteryPopDistributionID}`;
  if (typeof autoplay !== 'undefined') src += `&autoplay=${autoplay}`;
  if (typeof autoresume !== 'undefined') src += `&autoresume=${autoresume}`;
  if (typeof mute !== 'undefined') src += `&mute=${mute}`;
  if (video) {
    const { externalID } = video;
    src += `&ms_uuid=${batteryPopSeriesID}&mi_uuid=${externalID}`;
  }

  return (
    <div className="VideoPlayer">
      <iframe
        title={video && video.title}
        width="100%"
        height="412"
        src={src}
        frameBorder="0"
        allowFullScreen={true}
        className="VideoPlayer__iframe"
      />
    </div>
  );
}

VideoPlayer.defaultProps = {
  autoplay: settings.IS_PROD,
};

export default VideoPlayer;
